import PropTypes from 'prop-types';

import { ListingCostsShape } from '../../constants/shapes';

import OnBookingClosed from './OnBookingClosed';
import BeforeMoveIn from './BeforeMoveIn';

import styles from './PaymentDetails.module.scss';

const PaymentDetails = ({
  listingCosts = {},
  pricing = {},
  downPaymentTimeInterval = undefined,
  isInstantBooking = false,
  hasNoDeposit = false,
  currencyIsoCode
}) => {
  return (
    <div className={styles['payment-details']}>
      <OnBookingClosed
        currencyCode={currencyIsoCode}
        pricing={pricing}
        costs={listingCosts?.onBookingClosed}
        downPaymentTimeInterval={downPaymentTimeInterval}
        isInstantBooking={isInstantBooking}
      />
      <BeforeMoveIn
        currencyCode={currencyIsoCode}
        costs={listingCosts?.onCheckIn}
        hasNoDeposit={hasNoDeposit}
      />
    </div>
  );
};

PaymentDetails.propTypes = {
  pricing: PropTypes.shape({
    currencyCode: PropTypes.string,
    currencyIsoCode: PropTypes.string,
    totalContractValue: PropTypes.number
  }),
  listingCosts: PropTypes.shape({
    onBookingClosed: ListingCostsShape,
    onCheckIn: ListingCostsShape
  }),
  downPaymentTimeInterval: PropTypes.shape({
    type: PropTypes.oneOf(['months', 'weeks']),
    value: PropTypes.number
  }),
  isInstantBooking: PropTypes.bool,
  hasNoDeposit: PropTypes.bool,
  currencyIsoCode: PropTypes.string.isRequired
};

export default PaymentDetails;
